export default __webpack_public_path__ + "static/media/city_events.40f6d5ae.svg";